export default __webpack_public_path__ + "static/media/premier-league-banner.96b0f46c.webp";